export default "__VITE_PUBLIC_ASSET__bd90cc72__"